import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withTranslation } from '@wix/yoshi-flow-editor';

import SlideMenuIcon from '../../../../assets/top-menu.svg';
import {
  openSlideMenu,
  closeSlideMenu,
} from '../../../../redux/actions/slide-menu';
import { shouldShowMenuButton } from '../../ui-selectors/slide-menu';

const mapStateToProps = (state, props) => ({
  isSlideMenuOpened: state.slideMenuOpened,
  shouldBeShown: props.alwaysShow || shouldShowMenuButton(state, props),
});

const mapDispatchToProps = {
  openSlideMenu,
  closeSlideMenu,
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    class SlideMenuButton extends React.Component {
      static propTypes = {
        videoItem: PropTypes.object,
        channelData: PropTypes.object,

        className: PropTypes.string,
        iconClassName: PropTypes.string,

        isSlideMenuOpened: PropTypes.bool,
        alwaysShow: PropTypes.bool,
        shouldBeShown: PropTypes.bool,
        isFirstVideo: PropTypes.bool,

        openSlideMenu: PropTypes.func,
        closeSlideMenu: PropTypes.func,

        autoFocus: PropTypes.bool,
        tabIndex: PropTypes.number,
      };

      static defaultProps = {
        autoFocus: false,
        tabIndex: 0,
      };

      constructor(props) {
        super(props);

        this.slideMenuButtonRef = React.createRef();
      }

      handleClick = () => {
        const { isSlideMenuOpened, openSlideMenu, closeSlideMenu } = this.props;

        if (isSlideMenuOpened) {
          closeSlideMenu();
        } else {
          openSlideMenu();
        }
      };

      componentDidMount() {
        if (this.slideMenuButtonRef.current && this.props.autoFocus) {
          this.slideMenuButtonRef.current.focus();
        }
      }

      render() {
        const {
          className,
          iconClassName,
          shouldBeShown,
          tabIndex = 0,
        } = this.props;

        return (
          shouldBeShown && (
            <button
              ref={this.slideMenuButtonRef}
              data-hook="slide-menu-button"
              className={className}
              onClick={this.handleClick}
              tabIndex={tabIndex}
              aria-label={this.props.t(
                'widget.mobile.slide-menu-button-accessibility',
              )}
              style={{ color: 'inherit' }}
            >
              <SlideMenuIcon className={iconClassName} />
            </button>
          )
        );
      }
    },
  ),
);
